module.exports = {"Born1":{"daobanList":[{"title":"1:是否办理住房公积金个人住房贷款购房一件事","values":[{"name":"是","xuanzhong":1,"cailiaoList":[{"name":"1、广东省异地就医生育保险登记备案表-参保人使用","state":"必要"},{"name":"2、有效身份证件或医保电子凭证或社会保障卡","state":"必要"}]},{"name":"否","xuanzhong":1,"cailiaoList":[{}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/yytx27.json
// module id = 1325
// module chunks = 0